<template>
  <div class="confirm-stage active">
    <div class="d-title">
      <span class="lbl-cap8 text-bold">Contact Info:</span>
      <div class="action-edit" @click="gotoEdit()" v-if="user.first_name">
        Edit
      </div>
    </div>
    <div class="d-detail" v-if="user.first_name">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1 md-b15"></div>
        <div class="flex-1 md-b15">
          <div class="lbl-cap7 text-bold">Your Info</div>
          <div class="lbl-cap6">
            {{ user.first_name }}
            {{ user.last_name }}
          </div>
          <div class="lbl-cap6">{{ user.phone }}</div>
          <div class="lbl-cap6">{{ user.email }}</div>
        </div>
        <div class="flex-1 md-b15">
          <div class="lbl-cap7 text-bold">About My Project</div>
          <div class="lbl-cap6">{{ user.notes }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    gotoEdit() {
      this.$emit("gotoEdit");
    },
  },
};
</script>
